import type { IWelcomeCarouselSlideConstructorParams } from "@services/sdk";

class WelcomeCarouselSlide {
	static Defaults(): Array<WelcomeCarouselSlide> {
		const arrParams: Array<IWelcomeCarouselSlideConstructorParams> = [];
		return WelcomeCarouselSlide.ConstructList(arrParams);
	}

	static ConstructList(
		arrParams: Array<IWelcomeCarouselSlideConstructorParams>,
	): Array<WelcomeCarouselSlide> {
		arrParams.sort((a, b) => a.sortOrder - b.sortOrder);
		return arrParams.map((param) => new WelcomeCarouselSlide(param));
	}

	static Construct(
		params: IWelcomeCarouselSlideConstructorParams,
	): WelcomeCarouselSlide {
		return new WelcomeCarouselSlide(params);
	}

	responseData: IWelcomeCarouselSlideConstructorParams;

	constructor(params: IWelcomeCarouselSlideConstructorParams) {
		this.responseData = params;
	}

	get headline(): string {
		return this.responseData.headline;
	}

	get text(): string {
		return this.responseData.text;
	}

	get iconRef(): string {
		return this.responseData.iconRef;
	}

	get sortOrder(): number {
		return this.responseData.sortOrder;
	}
}

export default WelcomeCarouselSlide;
